import { IReference } from '@/_types'

import type { ReferenceSlideDirection } from './a-references-swiper.utils'

const ReferenceFacePhoto = ({ reference }: { reference: IReference }) => (
	<div className='references-face-stack__media'>
		{reference.authorPhoto ? (
			<img
				src={reference.authorPhoto.url}
				alt={`Medante - ${reference.author}`}
				className='references-face-stack__photo'
				draggable={false}
			/>
		) : (
			<div className='references-face-stack__placeholder' />
		)}
	</div>
)

type FaceLayerRole = 'visible' | 'under' | 'entering' | 'hidden'

const getFaceLayerRole = (
	index: number,
	activeIndex: number,
	enteringIndex: number | null
): FaceLayerRole => {
	if (enteringIndex === null) {
		return index === activeIndex ? 'visible' : 'hidden'
	}

	if (index === enteringIndex) return 'entering'
	if (index === activeIndex) return 'under'
	return 'hidden'
}

interface AReferencesFaceStackProps {
	references: IReference[]
	activeIndex: number
	enteringIndex: number | null
	slideDirection: ReferenceSlideDirection
	onEnterAnimationEnd: () => void
}

export const AReferencesFaceStack = ({
	references,
	activeIndex,
	enteringIndex,
	slideDirection,
	onEnterAnimationEnd
}: AReferencesFaceStackProps) => (
	<div className='references-face-stack'>
		<div className='references-face-stack__frame'>
			{references.map((reference, index) => {
				const role = getFaceLayerRole(index, activeIndex, enteringIndex)

				return (
					<div
						key={reference.id}
						className={`references-face-stack__layer references-face-stack__layer--${role}${role === 'entering' ? ` references-face-stack__layer--enter-${slideDirection}` : ''}`}
						aria-hidden={role === 'hidden'}
						onAnimationEnd={
							role === 'entering'
								? event => {
										if (event.target !== event.currentTarget) return
										onEnterAnimationEnd()
									}
								: undefined
						}
					>
						<ReferenceFacePhoto reference={reference} />
					</div>
				)
			})}
		</div>
	</div>
)
